const router = [
  {
    path: '/case',
    name: 'case',
    component: () => import('./Case'),
  },
]

export default router
